module.exports = __webpack_public_path__ + "img/error-img.231018a5.png";